import { flyingTulipConfigFor } from '@1delta/data-sdk'
import { Call } from '../../../utils/multicall'

/**
 * User-data call build for Flying Tulip. The account IS the position —
 * CROSS-MARGIN, one `PositionsManager` per chain, no ids, no sub-accounts,
 * no discovery — so the whole read is ONE lens call:
 *
 *   LendingLens.userPortfolio(account)
 *     → (collAssets[], collAvail[], collHold[], debtAssets[], debtUnitsNow[],
 *        equityUSDWad, maintUSDWad, hfBps)
 *
 * Both legs AND the protocol's own health aggregate arrive together. The
 * aggregate is AUTHORITATIVE — `equity` folds `enginePnL` in (zero today, live
 * the day Futures ships), so never recompute health from the legs. Debt is
 * previewed to `block.timestamp`; the stored figure is a floor.
 */
export const FLYING_TULIP_USER_CALLS = 1

export const buildFlyingTulipUserCall = (
  chainId: string,
  lender: string,
  account: string,
): Call[] => {
  const cfg = flyingTulipConfigFor(lender, chainId)
  if (!cfg?.lendingLens) return []
  return [
    { address: cfg.lendingLens, name: 'userPortfolio', params: [account] },
  ]
}
